import React from "react";
import { SVG, IconProps } from "../SVG";

export const DollarStack = ({ color = "#13126C", strokeWidth = "2", ...props }: IconProps) => (
    <SVG viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M5 16.5V19C5 19.5523 5.44772 20 6 20H22C22.5523 20 23 19.5523 23 19V9C23 8.44772 22.5523 8 22 8H20"
            stroke={color}
            strokeWidth={strokeWidth}
        />
        <rect x="1" y="4" width="18" height="12" rx="1" stroke={color} strokeWidth={strokeWidth} />
        <path
            d="M10 6V7.45433M11.6667 7.45433H9.16667C8.85725 7.45433 8.5605 7.58842 8.34171 7.82711C8.12292 8.06579 8 8.38951 8 8.72706C8 9.06461 8.12292 9.38833 8.34171 9.62701C8.5605 9.8657 8.85725 9.99979 9.16667 9.99979H10.8333C11.1428 9.99979 11.4395 10.1339 11.6583 10.3726C11.8771 10.6112 12 10.935 12 11.2725C12 11.6101 11.8771 11.9338 11.6583 12.1725C11.4395 12.4112 11.1428 12.5452 10.8333 12.5452H10M8 12.5452H9.41667H10M10 12.5452V14"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SVG>
);

DollarStack.displayName = "DollarStack";
